// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SwitcherOutlinedSvg from "@fishx/icons-svg/es/asn/SwitcherOutlined";
import FishxIcon from '../components/FishxIcon';

var SwitcherOutlined = function SwitcherOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SwitcherOutlinedSvg
  }));
};

SwitcherOutlined.displayName = 'SwitcherOutlined';
export default React.forwardRef(SwitcherOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SwitcherOutlined.js
// module id = 4213
// module chunks = 0